import * as i0 from '@angular/core';
import { Directive, Input, NgModule, HostBinding, Injectable, EventEmitter, Component, ViewEncapsulation, Output, forwardRef, ViewChild, Inject, ViewChildren, HostListener } from '@angular/core';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i1 from '@angular/material/select';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import * as i2 from '@angular/forms';
import { ReactiveFormsModule, FormControl, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import * as i1$2 from '@angular/material/slider';
import { MatSliderChange, MatSliderModule } from '@angular/material/slider';
import { startWith, map } from 'rxjs/operators';
import { extractTouchedChanges } from '@one/angular-kit/util';
import addMinutes from 'date-fns/addMinutes';
import format from 'date-fns/format';
import hoursToMinutes from 'date-fns/hoursToMinutes';
import setHours from 'date-fns/setHours';
import setMinutes from 'date-fns/setMinutes';
import * as i2$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i4 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import * as i5$1 from '@angular/material/datepicker';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import * as i1$3 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i3$1 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i6 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';

class OneSelectDropdownDirective {
    constructor(select, hostElement, renderer) {
        this.select = select;
        this.hostElement = hostElement;
        this.renderer = renderer;
        this.size = 'big';
        this.appearance = 'fill';
        this.disabledClass = 'one-select-disabled';
        this.addClass = (clsString, newClass) => clsString + ' ' + newClass;
        this.select.disableOptionCentering = true;
    }
    ngDoCheck() {
        var _a;
        this.select.disabled
            ? this.renderer.addClass(this.matFormField, this.disabledClass)
            : this.renderer.removeClass(this.matFormField, this.disabledClass);
        if (((_a = this.select.optionGroups) === null || _a === void 0 ? void 0 : _a.length) && this.select.panelClass !== undefined) {
            this.select.panelClass = this.addClass(this.select.panelClass, 'one-select-panel-optgroup');
        }
    }
    ngOnInit() {
        const sizeClass = this.size === 'small' ? 'one-select-small' : 'one-select-big';
        const appearanceClass = this.appearance === 'outline' ? 'one-select-outlined' : 'one-select-filled';
        this.addPanelClasses();
        // Get parent mat-form-field
        this.matFormField = this.hostElement.nativeElement.closest('mat-form-field');
        // Need to add .one-select to identify mat-form-field with one-select
        this.renderer.addClass(this.matFormField, 'one-select');
        // Set classes to mat-form-field so all styles continue working in same way
        this.renderer.addClass(this.matFormField, appearanceClass);
        this.renderer.addClass(this.matFormField, sizeClass);
    }
    addPanelClasses() {
        let newPanelClasses = '';
        if (this.select.panelClass !== undefined) {
            newPanelClasses = this.addClass(newPanelClasses, this.select.panelClass);
        }
        if (this.size === 'small') {
            newPanelClasses = this.addClass(newPanelClasses, 'one-select-panel-small');
        }
        else if (this.size === 'big') {
            newPanelClasses = this.addClass(newPanelClasses, 'one-select-panel-big');
        }
        if (this.select.multiple) {
            newPanelClasses = this.addClass(newPanelClasses, 'one-select-panel-multiple');
        }
        this.select.panelClass = newPanelClasses;
    }
}
OneSelectDropdownDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSelectDropdownDirective, deps: [{ token: i1.MatSelect }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
OneSelectDropdownDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneSelectDropdownDirective, selector: "mat-select[oneSelect]", inputs: { size: "size", appearance: "appearance" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSelectDropdownDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-select[oneSelect]',
                }]
        }], ctorParameters: function () { return [{ type: i1.MatSelect }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { size: [{
                type: Input
            }], appearance: [{
                type: Input
            }] } });

class OneSelectDropdownModule {
}
OneSelectDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSelectDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneSelectDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSelectDropdownModule, declarations: [OneSelectDropdownDirective], imports: [CommonModule, MatFormFieldModule, MatInputModule, MatSelectModule, ReactiveFormsModule], exports: [OneSelectDropdownDirective, MatSelect] });
OneSelectDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSelectDropdownModule, imports: [[CommonModule, MatFormFieldModule, MatInputModule, MatSelectModule, ReactiveFormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSelectDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneSelectDropdownDirective],
                    exports: [OneSelectDropdownDirective, MatSelect],
                    imports: [CommonModule, MatFormFieldModule, MatInputModule, MatSelectModule, ReactiveFormsModule],
                }]
        }] });

class OneFormFieldDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    ngAfterViewInit() {
        this.renderer.addClass(this.el.nativeElement, 'one-form-field');
    }
}
OneFormFieldDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFormFieldDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
OneFormFieldDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneFormFieldDirective, selector: "mat-form-field[oneFormField]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFormFieldDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-form-field[oneFormField]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

const SEARCH_FIELD_CSS_CLASS = 'one-search-field';
const SEARCH_FIELD_SQUARED_CSS_CLASS = 'one-search-field-squared';
const SEARCH_FIELD_ROUNDED_CSS_CLASS = 'one-search-field-rounded';
var oneSearchFieldBorder;
(function (oneSearchFieldBorder) {
    oneSearchFieldBorder["squared"] = "squared";
    oneSearchFieldBorder["rounded"] = "rounded";
})(oneSearchFieldBorder || (oneSearchFieldBorder = {}));
var oneSearchFieldAppearance;
(function (oneSearchFieldAppearance) {
    oneSearchFieldAppearance["fill"] = "fill";
    oneSearchFieldAppearance["outline"] = "outline";
})(oneSearchFieldAppearance || (oneSearchFieldAppearance = {}));
var oneSearchFieldSize;
(function (oneSearchFieldSize) {
    oneSearchFieldSize["regular"] = "regular";
    oneSearchFieldSize["slim"] = "slim";
})(oneSearchFieldSize || (oneSearchFieldSize = {}));
class OneSearchFieldDirective {
    constructor(renderer, el, matFormField) {
        this.renderer = renderer;
        this.el = el;
        this.matFormField = matFormField;
        this.appearance = oneSearchFieldAppearance.fill;
        this.oneSearchFieldSize = oneSearchFieldSize.slim;
        this.oneSearchFieldBorder = oneSearchFieldBorder.rounded;
    }
    get slim() {
        return this.oneSearchFieldSize === oneSearchFieldSize.slim;
    }
    get regular() {
        return this.oneSearchFieldSize === oneSearchFieldSize.regular;
    }
    get rounded() {
        return this.oneSearchFieldBorder === oneSearchFieldBorder.rounded;
    }
    get squared() {
        return this.oneSearchFieldBorder === oneSearchFieldBorder.squared;
    }
    get oneSearchFieldAppearance() {
        return this.appearance;
    }
    set oneSearchFieldAppearance(value) {
        this.appearance = value;
        this.matFormField.appearance = value === oneSearchFieldAppearance.fill ? 'fill' : 'standard';
    }
    get fill() {
        return this.appearance === oneSearchFieldAppearance.fill;
    }
    get outline() {
        return this.appearance === oneSearchFieldAppearance.outline;
    }
    ngOnInit() {
        this.matFormField.floatLabel = 'never';
        this.renderer.addClass(this.el.nativeElement, SEARCH_FIELD_CSS_CLASS);
    }
}
OneSearchFieldDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSearchFieldDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1$1.MatFormField }], target: i0.ɵɵFactoryTarget.Directive });
OneSearchFieldDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneSearchFieldDirective, selector: "mat-form-field[oneSearchField]", inputs: { oneSearchFieldSize: "oneSearchFieldSize", oneSearchFieldBorder: "oneSearchFieldBorder", oneSearchFieldAppearance: "oneSearchFieldAppearance" }, host: { properties: { "class.one-search-field-slim": "this.slim", "class.one-search-field-regular": "this.regular", "class.one-search-field-rounded": "this.rounded", "class.one-search-field-squared": "this.squared", "class.one-search-field-fill": "this.fill", "class.one-search-field-outline": "this.outline" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSearchFieldDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-form-field[oneSearchField]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1$1.MatFormField }]; }, propDecorators: { oneSearchFieldSize: [{
                type: Input
            }], slim: [{
                type: HostBinding,
                args: ['class.one-search-field-slim']
            }], regular: [{
                type: HostBinding,
                args: ['class.one-search-field-regular']
            }], oneSearchFieldBorder: [{
                type: Input
            }], rounded: [{
                type: HostBinding,
                args: ['class.one-search-field-rounded']
            }], squared: [{
                type: HostBinding,
                args: ['class.one-search-field-squared']
            }], oneSearchFieldAppearance: [{
                type: Input
            }], fill: [{
                type: HostBinding,
                args: ['class.one-search-field-fill']
            }], outline: [{
                type: HostBinding,
                args: ['class.one-search-field-outline']
            }] } });

class OneTextAreaDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    ngAfterViewInit() {
        this.renderer.addClass(this.el.nativeElement, 'one-text-area');
    }
}
OneTextAreaDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTextAreaDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
OneTextAreaDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneTextAreaDirective, selector: "mat-form-field[oneTextArea]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTextAreaDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-form-field[oneTextArea]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; } });

class OneDisableControlDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
    }
    set oneDisableControl(condition) {
        const action = condition ? 'disable' : 'enable';
        this.ngControl.control[action]();
    }
}
OneDisableControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDisableControlDirective, deps: [{ token: i2.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
OneDisableControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneDisableControlDirective, selector: "[oneDisableControl]", inputs: { oneDisableControl: "oneDisableControl" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneDisableControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[oneDisableControl]',
                }]
        }], ctorParameters: function () { return [{ type: i2.NgControl }]; }, propDecorators: { oneDisableControl: [{
                type: Input
            }] } });

class OneFormFieldModule {
}
OneFormFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFormFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneFormFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFormFieldModule, declarations: [OneFormFieldDirective, OneSearchFieldDirective, OneTextAreaDirective, OneDisableControlDirective], imports: [CommonModule], exports: [OneFormFieldDirective, OneSearchFieldDirective, OneTextAreaDirective, OneDisableControlDirective] });
OneFormFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFormFieldModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneFormFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneFormFieldDirective, OneSearchFieldDirective, OneTextAreaDirective, OneDisableControlDirective],
                    exports: [OneFormFieldDirective, OneSearchFieldDirective, OneTextAreaDirective, OneDisableControlDirective],
                    imports: [CommonModule],
                }]
        }] });

class OneQuickSelectionDatepickerService {
    constructor() {
        this.closeCalendarSource = new BehaviorSubject(false);
        this.isCloseCalendar = this.closeCalendarSource.asObservable();
    }
    setDate($date) {
        this.date = $date;
    }
    setDateShortcut($dateShortcut) {
        this.dateShortcut = $dateShortcut;
    }
    getDate() {
        return this.date;
    }
    getDateShortcut() {
        return this.dateShortcut;
    }
    closeCalendar(value) {
        this.closeCalendarSource.next(value);
    }
}
OneQuickSelectionDatepickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneQuickSelectionDatepickerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OneQuickSelectionDatepickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneQuickSelectionDatepickerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneQuickSelectionDatepickerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class OneQuickSelectionDatepickerModule {
}
OneQuickSelectionDatepickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneQuickSelectionDatepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneQuickSelectionDatepickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneQuickSelectionDatepickerModule, imports: [CommonModule] });
OneQuickSelectionDatepickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneQuickSelectionDatepickerModule, providers: [OneQuickSelectionDatepickerService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneQuickSelectionDatepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [OneQuickSelectionDatepickerService],
                }]
        }] });

class OneSliderComponent {
    constructor() {
        this.firstValueFormControl = new FormControl();
        this.secondValueFormControl = new FormControl();
        this.isRangeSlider = false;
        this.firstChange = new EventEmitter();
        this.secondChange = new EventEmitter();
        this.firstInput = new EventEmitter();
        this.secondInput = new EventEmitter();
        this.refreshFirstValue = true;
        this.refreshSecondValue = true;
        // TODO: link matslider objects to html objects and send them on ngAfterContentInit
        this.setShiftValue = (value) => (this.shiftValue * value) / 100;
    }
    set firstValue(value) {
        this.firstValueFormControl.setValue(value);
    }
    get firstValue() {
        return this.firstValueFormControl.value;
    }
    set secondValue(value) {
        this.secondValueFormControl.setValue(value);
    }
    get secondValue() {
        return this.secondValueFormControl.value;
    }
    firstValueChange(sliderChange) {
        if (this.refreshFirstValue) {
            this.refreshFirstValue = false;
            let resultValue = sliderChange;
            if (this.isRangeSlider && sliderChange.value >= this.secondValueFormControl.value) {
                const value = this.secondValueFormControl.value - this.setShiftValue(this.max);
                const correctedValue = value % this.step === 0 ? value : value - (value % this.step);
                sliderChange.value = correctedValue;
                this.firstValue = correctedValue;
                resultValue = new MatSliderChange();
                resultValue.value = this.firstValue;
            }
            else {
                this.firstValue = sliderChange.value;
            }
            this.firstChange.emit(resultValue);
        }
    }
    secondValueChange(sliderChange) {
        if (this.refreshSecondValue) {
            this.refreshSecondValue = false;
            let resultValue = sliderChange;
            if (this.isRangeSlider && sliderChange.value <= this.firstValueFormControl.value) {
                const value = this.firstValueFormControl.value + this.setShiftValue(this.max);
                const setValue = value % this.step === 0 ? value : value - (value % this.step) + this.step;
                this.secondValue = setValue;
                resultValue = new MatSliderChange();
                resultValue.value = this.secondValue;
            }
            else {
                this.secondValue = sliderChange.value;
            }
            this.secondChange.emit(resultValue);
        }
    }
    firstValueInput(event) {
        this.firstInput.emit(event);
    }
    secondValueInput(event) {
        this.secondInput.emit(event);
    }
    ngAfterContentInit() {
        this.firstValueChangeSubscription = this.firstValueFormControl.valueChanges.subscribe((value) => {
            this.refreshFirstValue ? this.firstValueChange({ value }) : (this.refreshFirstValue = true);
        });
        this.secondValueChangeSubscription = this.secondValueFormControl.valueChanges.subscribe((value) => {
            this.refreshSecondValue ? this.secondValueChange({ value }) : (this.refreshSecondValue = true);
        });
    }
    ngOnDestroy() {
        this.firstValueChangeSubscription.unsubscribe();
        this.secondValueChangeSubscription.unsubscribe();
    }
}
OneSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneSliderComponent, selector: "one-slider", inputs: { firstValue: "firstValue", secondValue: "secondValue", shiftValue: "shiftValue", isRangeSlider: "isRangeSlider", color: "color", displayWith: "displayWith", vertical: "vertical", tickInterval: "tickInterval", invert: "invert", max: "max", min: "min", step: "step", thumbLabel: "thumbLabel" }, outputs: { firstChange: "firstChange", secondChange: "secondChange", firstInput: "firstInput", secondInput: "secondInput" }, ngImport: i0, template: "<div class=\"slider-container\">\n  <mat-slider\n    [formControl]=\"firstValueFormControl\"\n    [invert]=\"invert\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [step]=\"step\"\n    [thumbLabel]=\"thumbLabel\"\n    [tickInterval]=\"tickInterval\"\n    [vertical]=\"vertical\"\n    class=\"one-slider\"\n    [ngClass]=\"{ 'first-slider': isRangeSlider }\"\n    (change)=\"firstValueChange($event)\"\n    (input)=\"firstValueInput($event)\"\n    [color]=\"color\"\n    [displayWith]=\"displayWith\"\n  >\n  </mat-slider>\n  <mat-slider\n    *ngIf=\"isRangeSlider\"\n    [formControl]=\"secondValueFormControl\"\n    [invert]=\"invert\"\n    [max]=\"max\"\n    [min]=\"min\"\n    [step]=\"step\"\n    [thumbLabel]=\"thumbLabel\"\n    [tickInterval]=\"tickInterval\"\n    [vertical]=\"vertical\"\n    class=\"one-slider second-slider\"\n    (change)=\"secondValueChange($event)\"\n    (input)=\"secondValueInput($event)\"\n    [color]=\"color\"\n    [displayWith]=\"displayWith\"\n  >\n  </mat-slider>\n</div>\n", styles: [".one-slider.mat-slider .mat-slider-thumb{transform:scale(.7)}.one-slider.mat-slider .mat-slider-thumb-label{width:32px;height:28px;right:-16px}.one-slider.mat-slider .mat-slider-thumb-label-text{font-weight:bold;transform:rotate(0)}.one-slider.mat-slider .mat-slider-track-wrapper{border-radius:4px}.one-slider.mat-slider .mat-slider-focus-ring{width:32px;height:32px}.one-slider.mat-slider:not(.mat-slider-disabled).cdk-mouse-focused .mat-slider-thumb{transform:scale(.7)}.one-slider.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label{border-radius:16px;transform:rotate(0)}.one-slider.mat-slider:not(.mat-slider-disabled).cdk-focused.mat-slider-thumb-label-showing .mat-slider-thumb{transform:scale(.7)}.one-slider.mat-slider-horizontal{height:48px}.one-slider.mat-slider-horizontal .mat-slider-wrapper{height:4px;top:22px}.one-slider.mat-slider-horizontal .mat-slider-wrapper:after{height:4px}.one-slider.mat-slider-horizontal .mat-slider-wrapper .mat-slider-ticks-container{height:4px}.one-slider.mat-slider-horizontal .mat-slider-wrapper .mat-slider-ticks-container .mat-slider-ticks{height:48px}.one-slider.mat-slider-horizontal .mat-slider-track-wrapper,.one-slider.mat-slider-horizontal .mat-slider-track-background,.one-slider.mat-slider-horizontal .mat-slider-track-fill,.one-slider.mat-slider-horizontal .mat-slider-track-ticks-container{height:4px}.one-slider.mat-slider-horizontal .mat-slider-focus-ring{top:-16px;right:-16px}.one-slider.mat-slider-vertical{width:48px}.one-slider.mat-slider-vertical .mat-slider-wrapper{width:4px;left:22px}.one-slider.mat-slider-vertical .mat-slider-wrapper:after{width:4px}.one-slider.mat-slider-vertical .mat-slider-wrapper .mat-slider-ticks-container{width:4px}.one-slider.mat-slider-vertical .mat-slider-wrapper .mat-slider-ticks-container .mat-slider-ticks{width:48px}.one-slider.mat-slider-vertical .mat-slider-track-wrapper,.one-slider.mat-slider-vertical .mat-slider-track-background,.one-slider.mat-slider-vertical .mat-slider-track-fill,.one-slider.mat-slider-vertical .mat-slider-track-ticks-container{width:4px}.one-slider.mat-slider-vertical .mat-slider-focus-ring{bottom:-16px;left:-16px}.one-slider.mat-slider.mat-slider-has-ticks:not(.mat-slider-disabled) .mat-slider-ticks,.one-slider.mat-slider.mat-slider-has-ticks.cdk-focused:not(.mat-slider-disabled) .mat-slider-ticks{opacity:1}.slider-container{position:relative;width:100%}.slider-container .first-slider .mat-slider-wrapper .mat-slider-track-wrapper{z-index:2}.slider-container .first-slider .mat-slider-wrapper .mat-slider-track-wrapper .mat-slider-track-background{background:none}.slider-container .first-slider .mat-slider-wrapper .mat-slider-ticks-container{z-index:2}.slider-container .first-slider .mat-slider-wrapper .mat-slider-thumb-container{z-index:3}.slider-container .second-slider{position:absolute;top:0;left:1px}.slider-container .second-slider .mat-slider-wrapper .mat-slider-track-wrapper{z-index:1}.slider-container .second-slider .mat-slider-wrapper .mat-slider-ticks-container{z-index:1}.slider-container .second-slider .mat-slider-wrapper .mat-slider-thumb-container{z-index:3}\n"], components: [{ type: i1$2.MatSlider, selector: "mat-slider", inputs: ["disabled", "color", "tabIndex", "invert", "max", "min", "step", "thumbLabel", "tickInterval", "value", "vertical", "displayWith", "valueText"], outputs: ["change", "input", "valueChange"], exportAs: ["matSlider"] }], directives: [{ type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i7.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSliderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-slider',
                    templateUrl: './slider.component.html',
                    styleUrls: ['./slider.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { firstValue: [{
                type: Input
            }], secondValue: [{
                type: Input
            }], shiftValue: [{
                type: Input
            }], isRangeSlider: [{
                type: Input
            }], color: [{
                type: Input
            }], displayWith: [{
                type: Input
            }], vertical: [{
                type: Input
            }], tickInterval: [{
                type: Input
            }], invert: [{
                type: Input
            }], max: [{
                type: Input
            }], min: [{
                type: Input
            }], step: [{
                type: Input
            }], thumbLabel: [{
                type: Input
            }], firstChange: [{
                type: Output
            }], secondChange: [{
                type: Output
            }], firstInput: [{
                type: Output
            }], secondInput: [{
                type: Output
            }] } });

class OneSliderModule {
}
OneSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSliderModule, declarations: [OneSliderComponent], imports: [CommonModule, MatSliderModule, FormsModule, ReactiveFormsModule], exports: [OneSliderComponent] });
OneSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSliderModule, imports: [[CommonModule, MatSliderModule, FormsModule, ReactiveFormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneSliderComponent],
                    imports: [CommonModule, MatSliderModule, FormsModule, ReactiveFormsModule],
                    exports: [OneSliderComponent]
                }]
        }] });

var oneEditableDropdownSize;
(function (oneEditableDropdownSize) {
    oneEditableDropdownSize["regular"] = "regular";
    oneEditableDropdownSize["slim"] = "slim";
})(oneEditableDropdownSize || (oneEditableDropdownSize = {}));
class OneEditableDropdownDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        this.oneEditableDropdownSize = oneEditableDropdownSize.regular;
    }
    get slim() {
        return this.oneEditableDropdownSize === oneEditableDropdownSize.slim;
    }
    get regular() {
        return this.oneEditableDropdownSize === oneEditableDropdownSize.regular;
    }
    ngAfterViewInit() {
        this.renderer.addClass(this.el.nativeElement, 'one-form-field');
        this.renderer.addClass(this.el.nativeElement, 'one-editable-dropdown');
    }
}
OneEditableDropdownDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneEditableDropdownDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
OneEditableDropdownDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: OneEditableDropdownDirective, selector: "mat-form-field[oneEditableDropdown]", inputs: { oneEditableDropdownSize: "oneEditableDropdownSize" }, host: { properties: { "class.one-editable-dropdown-slim": "this.slim", "class.one-editable-dropdown-regular": "this.regular" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneEditableDropdownDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-form-field[oneEditableDropdown]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { oneEditableDropdownSize: [{
                type: Input
            }], slim: [{
                type: HostBinding,
                args: ['class.one-editable-dropdown-slim']
            }], regular: [{
                type: HostBinding,
                args: ['class.one-editable-dropdown-regular']
            }] } });

class OneEditableDropdownModule {
}
OneEditableDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneEditableDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneEditableDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneEditableDropdownModule, declarations: [OneEditableDropdownDirective], imports: [CommonModule], exports: [OneEditableDropdownDirective] });
OneEditableDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneEditableDropdownModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneEditableDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneEditableDropdownDirective],
                    exports: [OneEditableDropdownDirective],
                    imports: [CommonModule]
                }]
        }] });

class OneTimepickerComponent {
    constructor() {
        this.step = 15;
        this.start = 0;
        this.end = 24;
        this.formDisabled = false;
        this.showPlaceholder = false;
        this.formControlTimepicker = new FormControl();
        this.options = [];
        this.disabled = false;
        this.onChangeFn = () => { };
        this.onTouchFn = () => { };
    }
    ngAfterViewInit() {
        this.formControlTimepicker.valueChanges.subscribe((x) => {
            this.onChangeFn(x);
        });
        this.touchedChanged$ = extractTouchedChanges(this.formControlTimepicker);
        this.touchedChanged$.subscribe((x) => {
            this.onTouchFn(x);
        });
    }
    writeValue(value) {
        this.formControlTimepicker.setValue(value);
        this.verifyPlaceholder();
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        isDisabled ? this.formControlTimepicker.disable() : this.formControlTimepicker.enable();
    }
    verifyPlaceholder() {
        if (this.placeholder && !this.formControlTimepicker.value) {
            this.showPlaceholder = true;
            this.inputTimepicker.nativeElement.setAttribute('type', 'text');
            this.formControlTimepicker.setValue(this.placeholder);
        }
        else {
            this.showPlaceholder = false;
            this.inputTimepicker.nativeElement.setAttribute('type', 'time');
        }
    }
    getTimeOptions() {
        const interval = this.step;
        const timeOptions = [];
        const periods = hoursToMinutes(this.end - this.start);
        let startTimeFns = setMinutes(setHours(new Date(), this.start), 0);
        for (let i = 0; i <= periods; i += interval) {
            const startTimeValue = addMinutes(startTimeFns, i === 0 ? 0 : interval);
            timeOptions.push(format(startTimeValue, 'HH:mm'));
            startTimeFns = startTimeValue;
        }
        return timeOptions;
    }
    ngOnInit() {
        this.verifyPlaceholder();
        this.filteredOptions = this.resetFilter(this.formControlTimepicker);
        this.options = this.getTimeOptions();
    }
    openPanel(event, isOpen, trigger) {
        if (!this.disabled) {
            event.preventDefault();
            event.stopPropagation();
            this.filteredOptions = this.resetFilter(this.formControlTimepicker);
            trigger.openPanel();
        }
    }
    focusTimepicker() {
        if (this.showPlaceholder) {
            this.showPlaceholder = false;
            this.inputTimepicker.nativeElement.setAttribute('type', 'time');
        }
    }
    resetFilter(formControl) {
        return formControl.valueChanges.pipe(startWith(''), map((value) => this._filter(value)));
    }
    _filter(value) {
        const result = this.options.filter((option) => option.indexOf(value) === 0);
        return result && result[0] === value && result.length === 1
            ? this.options
            : this.options.filter((option) => option.indexOf(value) === 0);
    }
    ngOnChanges(changes) {
        let updateTimeOptions = false;
        if (changes.start && !changes.start.firstChange && changes.start.currentValue) {
            this.start = changes.start.currentValue;
            updateTimeOptions = true;
        }
        if (changes.end && !changes.end.firstChange && changes.end.currentValue) {
            this.end = changes.end.currentValue;
            updateTimeOptions = true;
        }
        if (changes.step && !changes.step.firstChange && changes.step.currentValue) {
            this.step = changes.step.currentValue;
            updateTimeOptions = true;
        }
        if (updateTimeOptions)
            this.options = this.getTimeOptions();
    }
}
OneTimepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTimepickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OneTimepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: OneTimepickerComponent, selector: "one-timepicker", inputs: { placeholder: "placeholder", step: "step", start: "start", end: "end", appearance: "appearance" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OneTimepickerComponent),
            multi: true,
        },
    ], viewQueries: [{ propertyName: "inputTimepicker", first: true, predicate: ["inputTimepicker"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<mat-form-field\n  [appearance]=\"appearance\"\n  class=\"one-form-field one-timepicker-form-field\"\n  (click)=\"openPanel($event, autoFillOptions.isOpen, triggerTimepicker)\"\n>\n  <mat-icon matPrefix>clock</mat-icon>\n  <input\n    #inputTimepicker\n    #triggerTimepicker=\"matAutocompleteTrigger\"\n    (change)=\"$event.preventDefault(); verifyPlaceholder()\"\n    (click)=\"focusTimepicker()\"\n    (focus)=\"focusTimepicker()\"\n    [formControl]=\"formControlTimepicker\"\n    [matAutocomplete]=\"autoFillOptions\"\n    matInput\n    [readonly]=\"showPlaceholder\"\n    [ngClass]=\"{'one-timepicker-placeholder': showPlaceholder}\"\n  />\n  <mat-autocomplete #autoFillOptions=\"matAutocomplete\" class=\"one-timepicker-options-panel\">\n    <mat-option (click)=\"writeValue(option)\" *ngFor=\"let option of filteredOptions | async\" [value]=\"option\">\n      {{ option }}\n    </mat-option>\n  </mat-autocomplete>\n</mat-form-field>\n", styles: [".mat-select-panel.ng-animating{visibility:hidden}.mat-select-panel.one-select-panel-small{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;margin-left:16px;padding:8px 0!important;min-width:100%!important;border-radius:4px;margin-top:28px}.mat-select-panel.one-select-panel-small .mat-option{height:48px}.mat-select-panel.one-select-panel-small .mat-option .mat-option-ripple .mat-ripple-element{opacity:.5}.mat-select-panel.one-select-panel-small .mat-option .mat-option-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px}.mat-select-panel.one-select-panel-small .mat-option.mat-selected{padding-left:12px}.mat-select-panel.one-select-panel-small.one-select-panel-multiple{margin-left:40px}.mat-select-panel.one-select-panel-big{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f;margin-left:16px;padding:8px 0!important;min-width:100%!important;border-radius:4px;margin-top:31px}.mat-select-panel.one-select-panel-big .mat-option{height:48px}.mat-select-panel.one-select-panel-big .mat-option .mat-option-ripple .mat-ripple-element{opacity:.5}.mat-select-panel.one-select-panel-big .mat-option .mat-option-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px}.mat-select-panel.one-select-panel-big .mat-option.mat-selected{padding-left:12px}.mat-select-panel.one-select-panel-big.one-select-panel-multiple{margin-left:40px;margin-top:27px}.mat-select-panel.one-select-panel-optgroup .mat-optgroup .mat-option{padding-left:32px}.mat-select-panel.one-select-panel-optgroup .mat-optgroup .mat-option.mat-selected{padding-left:28px}.mat-select-panel.one-select-panel-optgroup.one-select-panel-multiple .mat-optgroup .mat-option{padding-left:32px}.mat-select-panel.one-select-panel-optgroup.one-select-panel-multiple .mat-optgroup .mat-option.mat-selected{padding-left:28px}.mat-select-panel.one-select-panel-optgroup.one-select-panel-multiple{margin-left:38px;margin-top:31px}.cdk-overlay-backdrop.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.5)}one-timepicker input::-webkit-outer-spin-button,one-timepicker input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}one-timepicker input[type=number]{-moz-appearance:textfield}one-timepicker input[type=time]::-webkit-clear-button{display:none}one-timepicker input[type=time]::-webkit-calendar-picker-indicator,one-timepicker input[type=time]::-webkit-calendar-picker-indicator:focus{display:none}one-timepicker input[type=time]::-ms-clear{display:none}one-timepicker .one-timepicker-form-field.one-form-field{min-width:150px;width:150px;cursor:pointer}one-timepicker .one-timepicker-form-field.one-form-field.mat-form-field-disabled{cursor:default}one-timepicker .one-timepicker-form-field.one-form-field .mat-icon{position:inherit;top:7px;font-size:26px;left:-4px}one-timepicker .one-timepicker-form-field.one-form-field.mat-form-field-appearance-outline .mat-icon{top:5px}one-timepicker .one-timepicker-form-field.one-form-field.mat-form-field-appearance-outline .mat-input-element[type=time]{line-height:16px}one-timepicker .one-timepicker-form-field.one-form-field .mat-form-field-wrapper .mat-form-field-flex{height:48px;min-height:48px;font-size:16px}one-timepicker .one-timepicker-form-field.one-form-field .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix{margin-top:11px;margin-left:-3px;padding:4px 0 13px;border-top:none}one-timepicker .one-timepicker-form-field.one-form-field .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-suffix{margin-top:6px}one-timepicker .one-timepicker-form-field.one-form-field .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-prefix .mat-icon,one-timepicker .one-timepicker-form-field.one-form-field .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-suffix .mat-icon{line-height:1}one-timepicker .one-timepicker-form-field.one-form-field .mat-form-field-wrapper .mat-form-field-flex:after{content:\"\";width:inherit;height:inherit;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;border-radius:inherit;pointer-events:none}.mat-autocomplete-panel.one-timepicker-options-panel mat-option{font-size:14px}\n"], components: [{ type: i1$1.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i3.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i1$1.MatPrefix, selector: "[matPrefix]" }, { type: i5.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i7.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i7.AsyncPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTimepickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-timepicker',
                    templateUrl: './timepicker.component.html',
                    styleUrls: ['./timepicker.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => OneTimepickerComponent),
                            multi: true,
                        },
                    ],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { inputTimepicker: [{
                type: ViewChild,
                args: ['inputTimepicker', { static: true }]
            }], placeholder: [{
                type: Input
            }], step: [{
                type: Input
            }], start: [{
                type: Input
            }], end: [{
                type: Input
            }], appearance: [{
                type: Input
            }] } });

class OneTimepickerModule {
}
OneTimepickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTimepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneTimepickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTimepickerModule, declarations: [OneTimepickerComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatIconModule,
        MatInputModule], exports: [OneTimepickerComponent] });
OneTimepickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTimepickerModule, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatFormFieldModule,
            MatAutocompleteModule,
            MatIconModule,
            MatInputModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneTimepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [OneTimepickerComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatFormFieldModule,
                        MatAutocompleteModule,
                        MatIconModule,
                        MatInputModule
                    ],
                    exports: [OneTimepickerComponent]
                }]
        }] });

class TwoMonthPanelService {
    setDate($date) {
        this.date = $date;
    }
    setDateShortcut($dateShortcut) {
        this.dateShortcut = $dateShortcut;
    }
    setEndDate($endDate) {
        this.endDate = $endDate;
    }
    setRadioSelectionTwoMonth($radioSelectionTwoMonth) {
        this.radioSelectionTwoMonth = $radioSelectionTwoMonth;
    }
    getDate() {
        return this.date;
    }
    getDateShortcut() {
        return this.dateShortcut;
    }
    getEndDate() {
        return this.endDate;
    }
    getRadioSelectionTwoMonth() {
        return this.radioSelectionTwoMonth;
    }
}
TwoMonthPanelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: TwoMonthPanelService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TwoMonthPanelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: TwoMonthPanelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: TwoMonthPanelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class TwoMonthPanelComponent {
    constructor(data, dialogRef, quickSelectionService, ref, renderer) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.quickSelectionService = quickSelectionService;
        this.ref = ref;
        this.renderer = renderer;
        this.radioSelection = new FormControl('');
        this.startDate = new FormControl('');
        this.endDate = new FormControl('');
    }
    ngOnInit() {
        this.updatePanelPosition();
    }
    ngAfterContentInit() {
        this.startDate = this.quickSelectionService.getDate();
        this.radioSelection = this.quickSelectionService.getRadioSelectionTwoMonth();
        this.endDate = this.quickSelectionService.getEndDate();
    }
    updatePanelPosition() {
        this.triggerElement = this.data;
        const leftPos = Number(this.triggerElement.left) - 45;
        // if there is enough area under the input, open below
        if (window.innerHeight - this.triggerElement.bottom >= this.triggerElement.panelHeight) {
            const topPos = Number(this.triggerElement.bottom) + 10;
            this.dialogRef.updatePosition({ top: topPos + 'px', left: leftPos + 'px' });
        } // open above
        else {
            const bottomPos = window.innerHeight - Number(this.triggerElement.top) + 15;
            this.dialogRef.updatePosition({ bottom: bottomPos + 'px', left: leftPos + 'px' });
        }
    }
    ngAfterViewInit() {
        this.renderer.addClass(document.querySelector('.cdk-overlay-backdrop'), 'cdk-overlay-transparent-backdrop');
    }
    ngAfterViewChecked() {
        if ((this.startDate.value === '' && this.calendars.first.activeDate.getMonth() === new Date().getMonth()) ||
            this.calendars.first.activeDate.getMonth() === new Date(this.startDate.value).getMonth()) {
            this.calendars.first.focusActiveCell();
        }
    }
    startDateChanged(event) {
        this.startDate.setValue(event);
        this.calendars.first.activeDate = this.startDate.value;
        if (this.startDate.value > this.endDate.value) {
            this.endDate.setValue('');
            const future = new Date(this.startDate.value);
            this.calendars.last._goToDateInView(future, 'month');
            this.ref.detectChanges();
        }
        this.calendars.first.updateTodaysDate();
        this.calendars.last.updateTodaysDate();
    }
    endDateChanged(event) {
        this.endDate.setValue(event);
        this.calendars.first.updateTodaysDate();
        this.calendars.last.updateTodaysDate();
        this.dialogRef.close();
    }
    setDateFilter(value) {
        const nextDate = new Date();
        this.startDate.setValue(new Date());
        nextDate.setDate(nextDate.getDate() + value);
        nextDate.setHours(0, 0, 0, 0);
        this.endDate.setValue(nextDate);
        this.calendars.first.updateTodaysDate();
        this.calendars.last.updateTodaysDate();
        if (value !== 10) {
            this.dialogRef.close();
        }
    }
    radioChange($event) {
        this.setDateFilter(parseInt($event.value, 10));
        this.calendars.first.updateTodaysDate();
        this.calendars.last.updateTodaysDate();
    }
    dateClass() {
        return (date) => {
            if (this.startDate.value === '' || this.endDate.value === '' || this.startDate.value > this.endDate.value) {
                return;
            }
            const firstDate = new Date(this.startDate.value);
            const lastDate = new Date(this.endDate.value);
            if (date > firstDate && date < lastDate) {
                return 'mat-calendar-body-in-range';
            }
            else if (date.getFullYear() === firstDate.getFullYear() &&
                date.getMonth() === firstDate.getMonth() &&
                date.getDate() === firstDate.getDate()) {
                return 'mat-calendar-body-range-start mat-calendar-body-in-range ';
            }
            else if (date.getFullYear() === lastDate.getFullYear() &&
                date.getMonth() === lastDate.getMonth() &&
                date.getDate() === lastDate.getDate()) {
                return 'mat-calendar-body-range-end mat-calendar-body-in-range';
            }
        };
    }
}
TwoMonthPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: TwoMonthPanelComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$3.MatDialogRef }, { token: TwoMonthPanelService }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
TwoMonthPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: TwoMonthPanelComponent, selector: "one-two-month-panel", viewQueries: [{ propertyName: "calendars", predicate: MatCalendar, descendants: true }], ngImport: i0, template: "<div mat-dialog-content>\n  <table class=\"two-month-panel\">\n    <div class=\"one-quick-selection\">\n      <div class=\"one-quick-selection-title\">Select range</div>\n      <mat-radio-group [formControl]=\"radioSelection\" (change)=\"radioChange($event)\" class=\"date-picker-radio-group\">\n        <mat-radio-button disabled class=\"radio-button\" value=\"0\" data-test-id=\"quick-datepicker-component.today\"\n          >Today\n        </mat-radio-button>\n        <mat-radio-button class=\"radio-button\" value=\"7\" data-test-id=\"quick-datepicker-component.next-week\"\n          >Next week\n        </mat-radio-button>\n        <mat-radio-button class=\"radio-button\" value=\"30\" data-test-id=\"quick-datepicker-component.next-month\"\n          >Next month\n        </mat-radio-button>\n        <mat-radio-button class=\"radio-button\" value=\"90\" data-test-id=\"quick-datepicker-component.next-three-months\"\n          >Next 3 months\n        </mat-radio-button>\n        <mat-radio-button class=\"radio-button\" value=\"10\" data-test-id=\"quick-datepicker-component.custom\"\n          >Custom\n        </mat-radio-button>\n      </mat-radio-group>\n    </div>\n    <div>\n      <mat-calendar\n        (selectedChange)=\"startDateChanged($event)\"\n        [selected]=\"startDate.value\"\n        [dateClass]=\"dateClass()\"\n        [startAt]=\"startDate.value\"\n      ></mat-calendar>\n    </div>\n    <div>\n      <mat-calendar\n        (selectedChange)=\"endDateChanged($event)\"\n        [selected]=\"endDate.value\"\n        [dateClass]=\"dateClass()\"\n        [startAt]=\"endDate.value\"\n        [minDate]=\"startDate.value\"\n      ></mat-calendar>\n    </div>\n  </table>\n</div>\n", styles: [".two-month-panel{display:flex;position:relative}.one-quick-selection{margin-left:10px}.one-quick-selection-title{margin-top:10px;padding:5px 0;font-size:16px;font-weight:500}mat-calendar{min-width:294px;height:344px}\n"], components: [{ type: i3$1.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { type: i5$1.MatCalendar, selector: "mat-calendar", inputs: ["startView", "startAt", "selected", "minDate", "maxDate", "headerComponent", "dateFilter", "dateClass", "comparisonStart", "comparisonEnd"], outputs: ["selectedChange", "yearSelected", "monthSelected", "viewChanged", "_userSelection"], exportAs: ["matCalendar"] }], directives: [{ type: i3$1.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: TwoMonthPanelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-two-month-panel',
                    templateUrl: 'two-month-panel.component.html',
                    styleUrls: ['two-month-panel.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$3.MatDialogRef }, { type: TwoMonthPanelService }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { calendars: [{
                type: ViewChildren,
                args: [MatCalendar]
            }] } });

class QuickTwoDateSelectionComponent {
    constructor(dialog, quickSelectionService, renderer, element) {
        this.dialog = dialog;
        this.quickSelectionService = quickSelectionService;
        this.renderer = renderer;
        this.element = element;
        this.startDateSelection = new FormControl('');
        this.endDateSelection = new FormControl('');
        this.radioSelection = new FormControl('');
        this.startDate = new EventEmitter();
        this.endDate = new EventEmitter();
        quickSelectionService.setDate(this.startDateSelection);
        quickSelectionService.setRadioSelectionTwoMonth(this.radioSelection);
        quickSelectionService.setEndDate(this.endDateSelection);
    }
    ngAfterViewChecked() {
        const matFormField = this.element.nativeElement.querySelector('mat-form-field');
        const invalidState = matFormField.querySelector('.mat-form-field-invalid');
        if (this.startDateSelection.value > this.endDateSelection.value && matFormField && !invalidState) {
            this.renderer.addClass(matFormField, 'mat-form-field-invalid');
        }
        else {
            this.renderer.removeClass(matFormField, 'mat-form-field-invalid');
        }
    }
    openDialog() {
        this.panelHeight = 350;
        const triggerElement = {
            top: this.inputRef.nativeElement.getBoundingClientRect().top,
            left: this.inputRef.nativeElement.getBoundingClientRect().left,
            bottom: this.inputRef.nativeElement.getBoundingClientRect().bottom,
            panelHeight: this.panelHeight,
        };
        const dialogRef = this.dialog.open(TwoMonthPanelComponent, {
            width: '750px',
            height: this.panelHeight + 'px',
            hasBackdrop: true,
            data: triggerElement,
        });
        dialogRef.afterClosed().subscribe(() => {
            if (this.startDateSelection.value <= this.endDateSelection.value) {
                this.startDate.emit(new Date(this.startDateSelection.value));
                this.endDate.emit(new Date(this.endDateSelection.value));
            }
        });
    }
    clearForm() {
        this.startDateSelection.setValue('');
        this.endDateSelection.setValue('');
        this.radioSelection.setValue('');
    }
}
QuickTwoDateSelectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: QuickTwoDateSelectionComponent, deps: [{ token: i1$3.MatDialog }, { token: TwoMonthPanelService }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
QuickTwoDateSelectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.5", type: QuickTwoDateSelectionComponent, selector: "one-quick-two-date-selection", outputs: { startDate: "startDate", endDate: "endDate" }, viewQueries: [{ propertyName: "inputRef", first: true, predicate: ["startInput"], descendants: true }], ngImport: i0, template: "<mat-form-field oneFormField appearance=\"fill\">\n  <mat-icon matPrefix>date</mat-icon>\n  <mat-label>Date</mat-label>\n  <mat-date-range-input matInput>\n    <input\n      #startInput\n      (click)=\"openDialog()\"\n      [formControl]=\"startDateSelection\"\n      matStartDate\n      placeholder=\"Start date\"\n    />\n    <input (click)=\"openDialog()\" [formControl]=\"endDateSelection\" matEndDate placeholder=\"End date\" />\n  </mat-date-range-input>\n  <button mat-icon-button one-icon-button matSuffix (click)=\"clearForm()\">\n    <mat-icon matSuffix data-test-id=\"basic-datepicker-component.clear-icon\">clear </mat-icon>\n  </button>\n</mat-form-field>\n", components: [{ type: i1$1.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i2$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i5$1.MatDateRangeInput, selector: "mat-date-range-input", inputs: ["separator", "comparisonStart", "comparisonEnd", "rangePicker", "required", "dateFilter", "min", "max", "disabled"], exportAs: ["matDateRangeInput"] }, { type: i6.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: OneFormFieldDirective, selector: "mat-form-field[oneFormField]" }, { type: i1$1.MatPrefix, selector: "[matPrefix]" }, { type: i1$1.MatLabel, selector: "mat-label" }, { type: i5$1.MatStartDate, selector: "input[matStartDate]", inputs: ["errorStateMatcher"], outputs: ["dateChange", "dateInput"] }, { type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i5$1.MatEndDate, selector: "input[matEndDate]", inputs: ["errorStateMatcher"], outputs: ["dateChange", "dateInput"] }, { type: i1$1.MatSuffix, selector: "[matSuffix]" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: QuickTwoDateSelectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'one-quick-two-date-selection',
                    templateUrl: './quick-two-date-selection.component.html',
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i1$3.MatDialog }, { type: TwoMonthPanelService }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { inputRef: [{
                type: ViewChild,
                args: ['startInput', { static: false }]
            }], startDate: [{
                type: Output
            }], endDate: [{
                type: Output
            }] } });

class QuickTwoDateSelectionModule {
}
QuickTwoDateSelectionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: QuickTwoDateSelectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
QuickTwoDateSelectionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: QuickTwoDateSelectionModule, declarations: [QuickTwoDateSelectionComponent, TwoMonthPanelComponent], imports: [CommonModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        ReactiveFormsModule,
        OneFormFieldModule,
        MatIconModule,
        MatButtonModule,
        FormsModule], exports: [QuickTwoDateSelectionComponent, TwoMonthPanelComponent] });
QuickTwoDateSelectionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: QuickTwoDateSelectionModule, providers: [TwoMonthPanelService], imports: [[
            CommonModule,
            MatNativeDateModule,
            MatDatepickerModule,
            MatFormFieldModule,
            MatInputModule,
            MatRadioModule,
            ReactiveFormsModule,
            OneFormFieldModule,
            MatIconModule,
            MatButtonModule,
            FormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: QuickTwoDateSelectionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [QuickTwoDateSelectionComponent, TwoMonthPanelComponent],
                    imports: [
                        CommonModule,
                        MatNativeDateModule,
                        MatDatepickerModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatRadioModule,
                        ReactiveFormsModule,
                        OneFormFieldModule,
                        MatIconModule,
                        MatButtonModule,
                        FormsModule,
                    ],
                    providers: [TwoMonthPanelService],
                    exports: [QuickTwoDateSelectionComponent, TwoMonthPanelComponent],
                }]
        }] });

class CustomKeyboardHandlerDirective {
    constructor(radioGroup, ngModel) {
        this.radioGroup = radioGroup;
        this.ngModel = ngModel;
    }
    listenEvent($event) {
        $event.stopPropagation();
        $event.preventDefault();
        if (this.radioGroup._radios) {
            const radioGroupArray = this.radioGroup._radios.filter((el) => el.disabled === false);
            const indexOfActive = radioGroupArray.findIndex(this.findIndexOfFocusedElement);
            if ($event.keyCode === 40) {
                // down arrow
                const newIndex = indexOfActive === radioGroupArray.length - 1 ? -1 : indexOfActive;
                radioGroupArray[newIndex + 1].focus();
            }
            else if ($event.keyCode === 38) {
                // up arrow
                const newIndex = indexOfActive === 0 ? radioGroupArray.length : indexOfActive;
                radioGroupArray[newIndex - 1].focus();
            }
            else if ($event.keyCode === 32) {
                //  space
                this.radioGroup.selected = radioGroupArray[indexOfActive];
                this.ngModel.viewToModelUpdate(this.radioGroup.selected.value);
            }
        }
    }
    findIndexOfFocusedElement(el) {
        return document.activeElement.id.search(el.id) !== -1;
    }
}
CustomKeyboardHandlerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: CustomKeyboardHandlerDirective, deps: [{ token: i3$1.MatRadioGroup }, { token: i2.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
CustomKeyboardHandlerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.5", type: CustomKeyboardHandlerDirective, selector: "[oneCustomKeyboardHandler]", host: { listeners: { "keydown": "listenEvent($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: CustomKeyboardHandlerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[oneCustomKeyboardHandler]',
                }]
        }], ctorParameters: function () { return [{ type: i3$1.MatRadioGroup }, { type: i2.NgControl }]; }, propDecorators: { listenEvent: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class OneRadioModule {
}
OneRadioModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneRadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OneRadioModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneRadioModule, declarations: [CustomKeyboardHandlerDirective], imports: [CommonModule], exports: [CustomKeyboardHandlerDirective] });
OneRadioModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneRadioModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: OneRadioModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CustomKeyboardHandlerDirective],
                    imports: [CommonModule],
                    exports: [CustomKeyboardHandlerDirective],
                }]
        }] });

/*
 * Public API Surface of form elements
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomKeyboardHandlerDirective, OneDisableControlDirective, OneEditableDropdownDirective, OneEditableDropdownModule, OneFormFieldDirective, OneFormFieldModule, OneQuickSelectionDatepickerModule, OneQuickSelectionDatepickerService, OneRadioModule, OneSearchFieldDirective, OneSelectDropdownDirective, OneSelectDropdownModule, OneSliderComponent, OneSliderModule, OneTextAreaDirective, OneTimepickerComponent, OneTimepickerModule, QuickTwoDateSelectionComponent, QuickTwoDateSelectionModule, TwoMonthPanelComponent, TwoMonthPanelService, oneSearchFieldAppearance, oneSearchFieldBorder, oneSearchFieldSize };
